import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import {  IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageMr2029 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    texmultiOccurrenceOptions: IMultiOccurrenceOptions;
    vatmultiOccurrenceOptions: IMultiOccurrenceOptions;
    estmultiOccurrenceOptions: IMultiOccurrenceOptions;
    tobmultiOccurrenceOptions: IMultiOccurrenceOptions;
    formulaireTyt: IFormulaire; 
}

/* @ngInject */
export default function Mr2029Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass
) {
    const vm: IPageMr2029 = this;


    vm.formulaireTyt = new Formulaire(' ',[
       new FormulaireItem('tytcod', {
            largeur: 33
        }),
        new FormulaireItem('tytdsc', {
            largeur: 33
        }), 
        new FormulaireItem('ecrcod', {
            largeur: 33
        }),
        new FormulaireItem('tytcom', {
            largeur: 100
        })
        ]);

    vm.texmultiOccurrenceOptions = {
        bloc: 'tex',        
        colonnesVisibles: [
            { nom: 'cexcod', largeur: 130 },
            { nom: 'cexdsc', largeur: 130 }
        ]
    };

    vm.vatmultiOccurrenceOptions = {
        bloc: 'vat',
        colonnesVisibles: [
            { nom: 'valcod', largeur: 130 },
            { nom: 'valdsc', largeur: 130 }
        ]
    };
    
    vm.estmultiOccurrenceOptions = {
        bloc: 'est',
        colonnesVisibles: [
            { nom: 'esycod', largeur: 110 },
            { nom: 'esydsc', largeur: 110 }
        ]
    };

    vm.tobmultiOccurrenceOptions = {
        bloc: 'tob',
        colonnesVisibles: [
            { nom: 'stamnetab', largeur: 110 },
            { nom: 'stadsc', largeur: 110 }
        ]
    }
}
